// extracted by mini-css-extract-plugin
export var columnList = "_j4-0";